<template>
  <v-container>
    <h1 class="display-1 font-weight-bold mx-1 mb-3">Marketing Tools</h1>
    <v-card>
      <v-card-text> Coming Soon </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  methods: {},
  async created() {},
};
</script>
